export const environment = {
  production: false,
  API: 'https://sigepo-portal-bff-dev.montreal.com.br/api/v1/',
  requestRetryTimes: 2,
  requestRetryInterval: 500,
  requestTimeout: 30000,
  downloadTimeout: 300000,
  recaptchaKey: "",
  useRecaptcha: false,
  systemName: "Jornal Minas Gerais - dev",
  country: "br",
  releaseVersion: "0.0.200",
  showNotificationModal: false,
  dataInicioVisualizacaoHtml: '2026-07-01'
};
